import React, { FC } from 'react'
import GeneralForm from '../../../Form'
import TextAreaInput from '../../../UI/Inputs/TextArea'
import { TFieldChangePayload } from '../../../../store/managePost/newTypes'
import { SOCIAL_NETWORK } from '../../../../models/post'
import { FormikHelpers } from 'formik'

interface FirstCommentFieldProps {
  isEditable: boolean
  onChange: (data: TFieldChangePayload) => any
  social: SOCIAL_NETWORK
  value: string | null
  isExist: boolean
  className: string
}

const FirstCommentField: FC<FirstCommentFieldProps> = ({
  children,
  className,
  social,
  isEditable,
  value,
  isExist,
  onChange
}) => {
  const setupForm = {
    initialValues: { first_comment: value || '' },
    validation: 'post',
    enableReinitialize: true,
    onSubmit: async (values: any, actions: FormikHelpers<any>) => {}
  }

  return isExist ? (
    <div className={className}>
      <GeneralForm {...setupForm}>
        <TextAreaInput
          disabled={!isEditable}
          minRows={1}
          maxRows={100}
          name='first_comment'
          placeholder='Type a comment...'
          postTextChange={onChange}
          social={social}
        >
          {children}
        </TextAreaInput>
      </GeneralForm>
    </div>
  ) : null
}

export default FirstCommentField
